export const SET_LOADER = "/screens/Loader/SET_LOADER";

export const setLoader = data => ({ type: SET_LOADER, data });